var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('router-view',{attrs:{"name":"header"}}),_c('v-main',[_c('router-view',{attrs:{"name":"main"}})],1),_c('div',{staticStyle:{"height":"50px"}}),_c('router-view',{attrs:{"name":"footer"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }